import { formatDate } from '@/utils';
import { IMessage } from "./context";
import { ISavedMessage } from "./types";

export const mapFromUserHistory = (messages?: ISavedMessage[]): IMessage[] =>
  (messages ?? []).map((message) => ({
    sender: message?.sender || 'USER',
    message: message?.message,
    date: message?.date,
    type: "html",
  }));

export const mapToUserHistory = (messages?: IMessage[]): ISavedMessage[] =>
  (messages ?? []).map((message) => ({
    sender: message?.sender || "USER",
    message: message?.message?.toString() || "",
    date: formatDate(message?.date),
  }));
